/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-param-reassign */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback } from 'react';
import {
  FLink,
  Button,
  TableRows,
  TableMobileIterative,
  LoadingIndicator,
  FModal,
  Icons,
} from '@components';
import { format } from 'date-fns';
import { currency } from '@utils';
import { SimularBeneficioService } from '@services';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { mdiAlertCircleOutline } from '@mdi/js';
import { ID_CONJUGADO, ID_VITALICIO } from '../Renda/utils';
import { BENEFICIOS } from '../../../../common/utils/paths';

export const Resultado = () => {
  const navigate = useNavigate();
  const dadosRenda = useSelector((state) => state.simulacaoBeneficio);
  const renda = dadosRenda;
  const beneficiarios = dadosRenda.beneficiariosChecked;
  const nomesBeneficiarios = beneficiarios.map((b) => b.nome);
  const idBeneficiarios = beneficiarios.map((b) => b.id);
  const beneficiarioCompleto = beneficiarios.map((b) => b);
  const simularBeneficioService = new SimularBeneficioService();
  const users = useSelector((state) => state.user);
  const [loading, setLoading] = useState(true);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [msgErro, setMsgErro] = useState('');

  const [resultadoSimulacao, setResultadoSimulacao] = useState([]);
  const [colunasTabela, setColunasTabela] = useState([]);
  const [linhasTabela, setLinhasTabela] = useState([]);

  const [pdfFile, setPdfFile] = useState('');

  const resultadoSimulacaoTemporario = (resultadoAPI) => {
    const simulacaoTemporarioModel = [
      `${resultadoAPI.IdadeAposentadoria} anos`,
      resultadoAPI.idadeFimBeneficio,
      resultadoAPI.terminoBeneficio,
      `${resultadoAPI.ValorSaldoContaTotalProjetado}`,
      `${resultadoAPI.ValorBeneficioTotal}`,
      `${renda.prazoRendaTemporaria} anos`,
      `${renda.percentualSaque} %`,
      `${resultadoAPI.ValorSaque}`,
    ];

    setLinhasTabela(simulacaoTemporarioModel);
  };

  const resultadoSimulacaoPercentualSaldo = (resultadoAPI) => {
    const simulacaoPercentualSaldoModel = [
      `${resultadoAPI.IdadeAposentadoria} anos`,
      `${resultadoAPI.ValorSaldoContaTotalProjetado}`,
      `${resultadoAPI.ValorBeneficioTotal}`,
      `${renda.percentualRendaMensal} %`,
      `${renda.percentualSaque} %`,
      `${resultadoAPI.ValorSaque}`,
    ];
    setLinhasTabela(simulacaoPercentualSaldoModel);
  };

  const resultadoSimulacaoVitalicio = (resultadoAPI) => {
    const simulacaoVitalicioModel = [
      `${resultadoAPI.IdadeAposentadoria} anos`,
      `R$ ${resultadoAPI.ValorBeneficioTotal}`,
      `R$ ${resultadoAPI.ValorBeneficioTotalRCM}`,
      `${renda.percentualSaque} %`,
      `R$ ${resultadoAPI.ValorSaque}`,
    ];

    setLinhasTabela(simulacaoVitalicioModel);
  };

  const resultadoTabelaSimulacaoConjugado = (resultadoAPI) => {
    const simulacaoVitalicioModel = [
      `${resultadoAPI.IdadeAposentadoria} anos`,
      `${renda.percentualSaque} %`,
      `R$ ${resultadoAPI.ValorSaque}`,
      `R$ ${resultadoAPI.ValorRemanBeneficio}`,
      `R$ ${resultadoAPI.ValorBeneficioTotal}`,
      `R$ ${resultadoAPI.ValorBeneficioTotalRCM}`,
    ];

    setLinhasTabela(simulacaoVitalicioModel);
  };

  const getSimularBeneficioParticipante = useCallback(async (values) => {
    if (values.percentualSaldoVitalicio === '')
      values.percentualSaldoVitalicio = 0;
    if (values.percentualRendaMensal === '') values.percentualRendaMensal = 0;
    if (values.percentualSaque === '') values.percentualSaque = 0;
    if (values.prazoRendaTemporaria === '') values.prazoRendaTemporaria = 0;
    if (values.retornoInvestimento !== 0)
      values.retornoInvestimento = values.retornoInvestimento.replace(',', '.');

    const result =
      await simularBeneficioService.getSimularBeneficioParticipante(
        values,
        users.matricula
      );

    if (result.CodErro !== null) {
      const calcUpf =
        Number(result.ValorUPF1.replace('.', '').replace(',', '.')) * 0.1;

      setMsgErro(
        result.CodErro === 'Msg05700'
          ? `Valor da renda variável inferior a ${currency(
              calcUpf
            )}. Gentileza alterar os percentuais informados.`
          : result.MsgErro
      );
      setModalIsOpen(true);
      setLoading(false);
      return;
    }

    const base64Relatorio =
      await simularBeneficioService.obterRelatorioResultadoSimulacao(
        values,
        users.matricula,
        users.token,
        beneficiarioCompleto
      );

    setPdfFile(`data:application/pdf;base64,${base64Relatorio}`);

    setResultadoSimulacao(result);

    switch (values.tipoRendaMensal) {
      case '1':
        resultadoSimulacaoPercentualSaldo(result);
        setColunasTabela([
          'Idade na data de aposentadoria',
          'Saldo total acumulado',
          'Benefício projetado total',
          'Percentual de renda',
          '% saque à vista',
          'Valor do saque à vista',
        ]);
        break;
      case '2':
        resultadoSimulacaoTemporario(result);
        setColunasTabela([
          'Idade na data de aposentadoria',
          'Idade no término da aposentadoria',
          'Término do benefício',
          'Saldo total acumulado',
          'Benefício projetado total',
          'Prazo renda temporária',
          '% saque à vista',
          'Valor do saque a vista',
        ]);
        break;
      case '3':
        resultadoSimulacaoVitalicio(result);
        setColunasTabela([
          'Idade na data de aposentadoria',
          'Renda vitalícia sem reversão para pensão',
          `Renda vitalícia com reversão para pensão ${dadosRenda.percentualrcm}%`,
          '% saque à vista',
          'Valor do saque a vista',
        ]);
        break;
      case '4':
        resultadoTabelaSimulacaoConjugado(result);
        setColunasTabela([
          'Idade na data de aposentadoria',
          '% saque à vista',
          'Valor do saque à vista',
          'Saldo remanescente para conversão em benefício',
          'Valor renda total sem reversão para pensão',
          `Valor renda total com reversão para pensão ${dadosRenda.percentualrcm}%`,
        ]);
        break;
      default:
        break;
    }

    setLoading(false);
  }, []);

  const insereBeneficiario = (values) => {
    values.codigosBeneficiario = idBeneficiarios;
  };

  const simularOutroValor = () => {
    navigate(BENEFICIOS);
  };

  useEffect(() => {
    insereBeneficiario(renda);
    getSimularBeneficioParticipante(renda);
  }, []);

  return (
    <>
      {!loading ? (
        <>
          <div className="card">
            <div className="card-body pb-0">
              <FLink
                className="justify-content-start mb-32"
                iconLeft="icon-arrow_back"
                onClick={() => navigate(-1)}
              >
                voltar
              </FLink>
              <h3 className="ts-20 fw-bold mb-2">Resultado da simulação</h3>
              <p className="ts-14 text-muted mb-32">
                O resultado exibido é mera simulação de cálculo, não existindo
                qualquer garantia do valor de benefício apresentado.
              </p>
              <div className="d-block d-md-flex flex-row mb-3">
                <div>
                  <p className="is-desktop ts-14 fw-bold mb-1">
                    Idade na aposentadoria
                  </p>
                  <p className="is-mobile ts-14 fw-normal mb-1">
                    Idade na aposentadoria
                  </p>
                  <p className="ts-32 fw-bold mb-3">
                    {resultadoSimulacao.IdadeAposentadoria}
                  </p>
                </div>
                <div className="ms-0 ms-md-32">
                  <p className="is-desktop ts-14 fw-bold mb-1">
                    Saldo total acumulado
                  </p>
                  <p className="is-mobile ts-14 fw-normal mb-1">
                    Saldo total acumulado
                  </p>
                  <p className="ts-32 fw-bold mb-3">
                    R$ {resultadoSimulacao.ValorSaldoContaTotalProjetado}
                  </p>
                </div>
              </div>
              {renda.tipoRendaMensal === ID_CONJUGADO && (
                <>
                  <div className="d-block d-md-flex flex-row mb-3">
                    <div>
                      <p className="is-desktop ts-14 fw-bold mb-1">
                        Percentual saldo a converter em renda vitalícia
                      </p>
                      <p className="is-mobile ts-14 fw-normal mb-1">
                        Percentual saldo a converter em renda vitalícia
                      </p>
                      <p className="ts-32 fw-bold mb-3">
                        {`${renda.percentualSaldoVitalicio}%`}
                      </p>
                    </div>
                    <div className="ms-0 ms-md-32">
                      <p className="is-desktop ts-14 fw-bold mb-1">
                        Valor saldo a converter em renda vitalícia
                      </p>
                      <p className="is-mobile ts-14 fw-normal mb-1">
                        Valor saldo a converter em renda vitalícia
                      </p>
                      <p className="ts-32 fw-bold mb-3">
                        {`R$ ${resultadoSimulacao.ValorSaldoContasTotalVitalicio}`}
                      </p>
                    </div>
                    <div className="ms-0 ms-md-32">
                      <p className="is-desktop ts-14 fw-bold mb-1">
                        Valor parcela vitalícia sem pensão
                      </p>
                      <p className="is-mobile ts-14 fw-normal mb-1">
                        Valor parcela vitalícia sem pensão
                      </p>
                      <p className="ts-32 fw-bold mb-3">
                        {currency(parseFloat(resultadoSimulacao.parcelaVit))}
                      </p>
                    </div>
                    <div className="ms-0 ms-md-32">
                      <p className="is-desktop ts-14 fw-bold mb-1">
                        Valor parcela vitalícia com {renda.percentualrcm} % de
                        reversão em pensão
                      </p>
                      <p className="is-mobile ts-14 fw-normal mb-1">
                        Valor parcela vitalícia com {renda.percentualrcm} % de
                        reversão em pensão
                      </p>
                      <p className="ts-32 fw-bold mb-3">
                        {currency(
                          parseFloat(resultadoSimulacao.parcelaVitReversao)
                        )}
                      </p>
                    </div>
                  </div>
                  <div className="d-block d-md-flex flex-row mb-3">
                    <div>
                      <p className="is-desktop ts-14 fw-bold mb-1">
                        Percentual a converter em renda variável
                      </p>
                      <p className="is-mobile ts-14 fw-normal mb-1">
                        Percentual a converter em renda variável
                      </p>
                      <p className="ts-32 fw-bold mb-3">
                        {`${100 - renda.percentualSaldoVitalicio}%`}
                      </p>
                    </div>
                    <div className="ms-0 ms-md-32">
                      <p className="is-desktop ts-14 fw-bold mb-1">
                        Valor saldo a converter em renda variável
                      </p>
                      <p className="is-mobile ts-14 fw-normal mb-1">
                        Valor saldo a converter em renda variável
                      </p>
                      <p className="ts-32 fw-bold mb-3">
                        {`R$ ${resultadoSimulacao.ValorSaldoContasTotalRendaVar}`}
                      </p>
                    </div>
                    <div className="ms-0 ms-md-32">
                      <p className="is-desktop ts-14 fw-bold mb-1">
                        Percentual do saldo
                      </p>
                      <p className="is-mobile ts-14 fw-normal mb-1">
                        Percentual do saldo
                      </p>
                      <p className="ts-32 fw-bold mb-3">
                        {`${renda.percentualRendaMensal}%`}
                      </p>
                    </div>
                    <div className="ms-0 ms-md-32">
                      <p className="is-desktop ts-14 fw-bold mb-1">
                        Valor parcela variável
                      </p>
                      <p className="is-mobile ts-14 fw-normal mb-1">
                        Valor parcela variável
                      </p>
                      <p className="ts-32 fw-bold mb-3">
                        {`R$ ${resultadoSimulacao.ValorBeneficioPercToTal}`}
                      </p>
                    </div>
                  </div>
                </>
              )}
              <p className="ts-14 text-muted mb-32">
                Data base para cálculo: {format(new Date(), 'dd/MM/yyyy')}
              </p>
              <TableRows
                className="is-desktop mb-4"
                columns={colunasTabela}
                line={linhasTabela}
              />
              <TableMobileIterative
                className=" mb-4"
                columns={colunasTabela}
                line={linhasTabela}
              />
              {dadosRenda.tipoRendaMensal === ID_VITALICIO &&
              dadosRenda.percentualrcm === 0 ? (
                <p className="ts-14 text-muted">
                  Sem beneficiários considerados
                </p>
              ) : (
                <>
                  <p className="is-mobile ts-14 text-black">
                    Beneficiários considerados: {nomesBeneficiarios.join(', ')}
                  </p>
                  <p className="is-desktop ts-14 text-muted">
                    Beneficiários considerados: {nomesBeneficiarios.join(', ')}
                  </p>
                </>
              )}
            </div>
            <div className="card-footer">
              <hr className="my-32" />
              <div className="row">
                <div className="d-block d-md-flex align-items-center ms-auto col-12 col-md-6">
                  <Button
                    transparent
                    color="orange"
                    className="mb-3 mb-md-0"
                    onClick={simularOutroValor}
                  >
                    Simular outro valor
                  </Button>

                  <a
                    href={pdfFile}
                    rel="noreferrer"
                    target="_blank"
                    download="simulação benefício"
                    title="Clique para baixar o pdf do protocolo"
                    className="ms-0 ms-md-3 aButton"
                  >
                    Visualizar
                  </a>
                </div>
              </div>
            </div>
          </div>
          <FModal
            isOpen={modalIsOpen}
            close={false}
            onClose={() => setModalIsOpen(false)}
          >
            <Icons path={mdiAlertCircleOutline} color="var(--error)" size={2} />
            <h1 className="ts-20 fw-bold mb-1">{msgErro}</h1>
            <Button
              className="mt-32"
              onClick={() => {
                navigate(BENEFICIOS);
              }}
            >
              Ok
            </Button>
          </FModal>
        </>
      ) : (
        <LoadingIndicator />
      )}
    </>
  );
};
